import React, { useState } from "react";
import { Card, Tabs, Dropdown, Popconfirm, Modal, Input, message } from "antd";
import { Provider as JotaiProvider, useAtom } from "jotai";
import {
  ListaContratos,
  ModalAprobar,
  ModalRechazar,
  ListaContratosSeguimiento,
  ModalTransferencia,
  ModalAdenda,
} from "./componentes";
import {
  CaretDownOutlined,
  NotificationOutlined,
  FileExcelOutlined,
  UserOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { ModalVisorPdf as VisorPdf } from "components/common";
import {
  urlPdfContratoAtom,
  visibleModalVisorPdfAtom,
} from "./BandejaAprobacionAdministracionPersonalStore";
import { ModalActualizarResponsables } from "./componentes/ModalActualizarResponsables";
import { ModalRenovarMasivamente } from "./componentes/ModalRenovarMasivamente";
import { BandejaAprobacionAdministracionPersonalService } from "services/contratos";

const BandejaAprobacionAdministracionPersonalPage = () => {
  const [visibleModalActualizarResponsables, setVisibleModalActualizarResponsables] = useState(false);
  const [visibleModalNotificarPorDNI, setVisibleModalNotificarPorDNI] = useState(false);
  const [visibleModalRenovarMasivamente, setVisibleModalRenovarMasivamente] = useState(false);
  const [dniNotificar, setDniNotificar] = useState("");

  const onClickBtnMasAcciones = (e) => {
		if (e.key === "notificar-masivo-responsable") {
      onclickBtnNotificarResponsables();
		} else if (e.key === "actualizar-masivo-responsable") {
      setVisibleModalActualizarResponsables(true);
    } else if (e.key === "notificar-individual-responsable") {
      setVisibleModalNotificarPorDNI(true);
    } else if (e.key === "renovar-masivo") {
      setVisibleModalRenovarMasivamente(true);
    }
	};

  const onclickBtnNotificarResponsables = async() =>{
    await BandejaAprobacionAdministracionPersonalService.notificarContratosPorVencerResponsables();
  }

  const onConfirmNotificarPorDNI = async () => {
    await BandejaAprobacionAdministracionPersonalService.notificarContratosPorVencerResponsablesPorDNI(dniNotificar);
    setVisibleModalNotificarPorDNI(false);
    setDniNotificar("");
    message.success("Notificación enviada correctamente al responsable.");
  };

  const operaciones = {
    right: (
      <Dropdown.Button
						menu={{
							items: [
                                {
									label: ( <Popconfirm
                                        title="¿Desea notificar los contratos por vencer masivamente a los responsables?"
                                        onConfirm={() => onClickBtnMasAcciones({ key: "notificar-masivo-responsable" })}
                                        okText="Sí"
                                        cancelText="No"
                                    >
                                        <span>
                                            Notificar Masivamente Responsables
                                        </span>
                                    </Popconfirm>),
									icon: <NotificationOutlined style={{ fontSize: "18px" }} />,
								},
								{
									label: "Renovar Masivamente",
									key: "renovar-masivo",
									icon: <SyncOutlined style={{ fontSize: "18px" }} />,
								},
								{
									label: "Actualizar Masivamente Responsables",
									key: "actualizar-masivo-responsable",
									icon: <FileExcelOutlined style={{ fontSize: "18px" }} />,
								},
								{
									label: "Notificar Individual Responsable",
									key: "notificar-individual-responsable",
									icon: <UserOutlined style={{ fontSize: "18px" }} />,
								},
							],
							onClick: onClickBtnMasAcciones,
						}}
						icon={<CaretDownOutlined />}
						trigger={["click"]}
						arrow
					>
						Acciones
				</Dropdown.Button>
    ),
  };

  return (
    <JotaiProvider>
      <ContainerTabs>
        <Tabs
          tabBarExtraContent={operaciones}
        > 
          <Tabs.TabPane
            tab="Contratos Pendientes de Aprobación"
            key="contrato-pendientes-aprobacion"
          >
            <ListaContratos />
            <ModalAprobar />
            <ModalRechazar />
            <ModalVisorPdf />
            <ModalTransferencia />
            <ModalAdenda />
            <ModalActualizarResponsables visible={visibleModalActualizarResponsables} setVisible={setVisibleModalActualizarResponsables}/>
            <ModalRenovarMasivamente visible={visibleModalRenovarMasivamente} setVisible={setVisibleModalRenovarMasivamente}/>
          </Tabs.TabPane>

          <Tabs.TabPane
            tab="Seguimiento de Contratos"
            key="seguimiento-aprobacion"
          >
            <ListaContratosSeguimiento />
          </Tabs.TabPane>
        </Tabs>
        <Modal
          title="Notificar Individual Responsable"
          open={visibleModalNotificarPorDNI}
          onOk={onConfirmNotificarPorDNI}
          onCancel={() => { setVisibleModalNotificarPorDNI(false); setDniNotificar(""); }}
          okText="Notificar"
          cancelText="Cancelar"
        >
          <Input
            placeholder="Ingrese número de documento de identidad"
            value={dniNotificar}
            onChange={(e) => setDniNotificar(e.target.value)}
            maxLength={8}
          />
        </Modal>
      </ContainerTabs>
    </JotaiProvider>
  );
};

const ModalVisorPdf = () => {
  const [visible, setVisible] = useAtom(visibleModalVisorPdfAtom);
  const [urlPdfContrato] = useAtom(urlPdfContratoAtom);

  return (
    <VisorPdf
      urlPdf={urlPdfContrato}
      visible={visible}
      onCerrar={() => setVisible(false)}
    />
  );
};

const ContainerTabs = ({ children }) => {
  return (
    <div style={{ padding: "10px 20px", background: "white" }}>{children}</div>
  );
};

export default BandejaAprobacionAdministracionPersonalPage;
